import { Modal } from "antd";
import { useState } from "react";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import Video from "../../../../Components/Icons/Video";
export const imagetype = ["png", "jpg", "jpeg", "PNG", "gif", "webp", "jfif"];
export const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx"];
export const videotype = ["mp4", "mov", "wmv", "avi", "flv", "mkv"];

const ViewFiles = ({ data }) => {
  let fileName = data && data?.split("/").reverse()[0];
  let fileType = data && data?.split(".").reverse()[0];
//   let fileSize = data && data?.file_size||0
console.log("lastimg",data);

  const [open, setOpen] = useState(false);

  function onCancel() {
    setOpen(false);
  }

  function getSize(x){
    if(1024<=x){
      let value = x/1024
      return `${value.toFixed(2)} MB`
    }else{
      return `${x.toFixed(2)} KB`
    }
  }

  return (
    <>
      <div className=" text-[#555E6C] cursor-pointer  text-xs font-normal w-40 flex gap-1  rounded-md p-1 overflow-hidden" style={{border:'1px solid #bfc2ca'}} onClick={() => setOpen(true)}>
        <div
          className="  inline gap-3 "
        >
          {imagetype?.includes(fileType) ? (
            <svg
              width="40"
              height="34"
              viewBox="0 0 40 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.93457"
                y="0.793579"
                width="38.3959"
                height="32.2554"
                rx="3"
                fill="#EBF0FF"
              />
              <path
                d="M31.519 5.79358H8.74605C8.26562 5.79358 7.80486 5.98443 7.46514 6.32415C7.12542 6.66387 6.93457 7.12463 6.93457 7.60506V26.2375C6.93457 26.7179 7.12542 27.1787 7.46514 27.5184C7.80486 27.8581 8.26562 28.0489 8.74605 28.0489H31.519C31.9994 28.0489 32.4602 27.8581 32.7999 27.5184C33.1396 27.1787 33.3305 26.7179 33.3305 26.2375V7.60506C33.3305 7.12463 33.1396 6.66387 32.7999 6.32415C32.4602 5.98443 31.9994 5.79358 31.519 5.79358ZM8.74605 7.34628H31.519C31.5876 7.34628 31.6535 7.37354 31.702 7.42208C31.7505 7.47061 31.7778 7.53643 31.7778 7.60506V22.291L27.6243 18.1375C27.2829 17.8009 26.8228 17.6122 26.3433 17.6122C25.8639 17.6122 25.4037 17.8009 25.0623 18.1375L22.3839 20.816C22.3609 20.8411 22.3329 20.8611 22.3017 20.8748C22.2705 20.8885 22.2369 20.8956 22.2028 20.8956C22.1687 20.8956 22.135 20.8885 22.1038 20.8748C22.0727 20.8611 22.0447 20.8411 22.0216 20.816L16.2378 15.0321C15.8965 14.6955 15.4363 14.5068 14.9569 14.5068C14.4774 14.5068 14.0173 14.6955 13.6759 15.0321L8.48727 20.2208V7.60506C8.48727 7.53643 8.51454 7.47061 8.56307 7.42208C8.6116 7.37354 8.67742 7.34628 8.74605 7.34628ZM31.519 26.4962H8.74605C8.67742 26.4962 8.6116 26.469 8.56307 26.4205C8.51454 26.3719 8.48727 26.3061 8.48727 26.2375V22.4204L14.7757 16.132C14.7987 16.1069 14.8267 16.0868 14.8579 16.0731C14.8891 16.0594 14.9228 16.0523 14.9569 16.0523C14.9909 16.0523 15.0246 16.0594 15.0558 16.0731C15.087 16.0868 15.115 16.1069 15.138 16.132L20.9218 21.9158C21.2632 22.2524 21.7234 22.4411 22.2028 22.4411C22.6822 22.4411 23.1424 22.2524 23.4838 21.9158L26.1622 19.2374C26.1852 19.2123 26.2132 19.1922 26.2444 19.1785C26.2756 19.1648 26.3093 19.1577 26.3433 19.1577C26.3774 19.1577 26.4111 19.1648 26.4423 19.1785C26.4734 19.1922 26.5014 19.2123 26.5245 19.2374L31.7778 24.4907V26.2375C31.7778 26.3061 31.7505 26.3719 31.702 26.4205C31.6535 26.469 31.5876 26.4962 31.519 26.4962ZM22.8368 14.217C22.7163 14.0965 22.621 13.9532 22.5566 13.7954C22.4922 13.6377 22.4599 13.4687 22.4616 13.2983C22.4616 12.9551 22.5979 12.626 22.8406 12.3834C23.0832 12.1407 23.4123 12.0044 23.7555 12.0044C24.0987 12.0044 24.4278 12.1407 24.6704 12.3834C24.9131 12.626 25.0494 12.9551 25.0494 13.2983C25.0494 13.6415 24.9131 13.9706 24.6704 14.2132C24.4278 14.4559 24.0987 14.5922 23.7555 14.5922C23.5851 14.5939 23.4161 14.5616 23.2583 14.4972C23.1006 14.4327 22.9573 14.3375 22.8368 14.217Z"
                fill="white"
              />
            </svg>
          ) : videotype?.includes(fileType) ? (
            <Video/>
          ) : null}
          {fileType == ("docx" || "doc") ? (
            <Doc />
          ) : fileType == ("xlsx" || "xls") ? (
            <Xls />
          ) : fileType == "txt" ? (
            <Txt />
          ) : fileType == "pdf" ? (
            <Pdf />
          ) : fileType == "pptx" ? (
            <>No file</>
          ) : null}
        </div>
        <div>
        <p className=" truncate text-[10px] font-medium w-full ">{fileName||"-"}</p>
        {/* <p className=" truncate text-[10px] font-medium ">Size : {getSize(fileSize)||"-"}</p> */}

        </div>
      </div>
      <Modal
        open={open}
        title="Attachment View"
        width={"80%"}
        centered
        onCancel={onCancel}
        footer={[]}
      >
        <div className="h-[86vh] overflow-hidden">
          <div className=" w-full h-full overflow-y-auto">
            {imagetype?.includes(fileType) ? (
              <img
                src={data}
                width="100%"
                //  className="m-auto w-full h-full"
                alt="file not found"
              />
            ) : null}

            {videotype?.includes(fileType) ? (
              <video width="100%" controls>
                <source src={data} type="video/mp4" />
              </video>
            ) : null}

            {filetype?.includes(fileType) ? (
              <iframe
                src={data}
                width="100%"
                height="100%"
                type="text"
                title={fileName}
              ></iframe>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewFiles;
